import { handleTextTooltip } from './components/text-tooltip';
import { handleAddToCart } from './modules/addToCart';
import { Compare } from './modules/Compare';
import { CopyLink } from './modules/CopyLink';
import { Favourties } from './modules/Favourites';
import { handleWoocommerceToasts } from './modules/handleWoocommerceToast';
import { WCProductConfigurator } from './components/configurator';

var documentReady = function () {
    
    const root = document.getElementById('product-configurator-root');
    if (root) {
        let configData = {};

        if (root.dataset.configurator) {
            try {
                configData = JSON.parse(root.dataset.configurator);
                Object.entries(configData).forEach(([type, group]) => {
                    if (group.show_if) return;
                    if (Array.isArray(group.condition)) {
                        group.show_if = group.condition
                            .filter((c) => c && c.group_key && c.operator)
                            .map((c) => ({
                                operator: c.operator === '=' ? 'equals' : 'not_equals',
                                key: c.value,
                                group: c.group_key
                            }));
                        return;
                    }
                    if (group.condition && group.condition.group_key) {
                        group.show_if = {
                            operator: group.condition.operator === '=' ? 'equals' : 'not_equals',
                            key: group.condition.value,
                            group: group.condition.group_key
                        };
                    }
                });
            } catch (e) {
                console.error('Błąd podczas parsowania danych konfiguratora:', e);
            }
        }

        window.wcConfigurator = new WCProductConfigurator(configData);
    }

    handleTextTooltip();
    handleWoocommerceToasts();
    handleAddToCart();
    new Favourties();
    new Compare();
    new CopyLink();
};

if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
    documentReady();
} else {
    document.addEventListener('DOMContentLoaded', documentReady);
}
